import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import "../../node_modules/font-awesome/css/font-awesome.min.css";
import { Loader } from "react-loaders";
import "./Home.css";
import Header from "./Header.js";
import Motivation from "./Motivation.js";
import Modal from "./Modal.js";
import BecomeMember from "./BecomeMember.js";
import SectionLabel from "./SectionLabel.js";
import { blogPosts } from "../shared/_constants.js";
// import concernsBoard from "../concerns-board.svg";
import kudosIcon from "../kudos_icon.svg";
import concernsIcon from "../concerns_icon.svg";
import arrow from "../arrow.svg";

class Home extends Component {
  constructor() {
    super();
    this.state = {
      showFreeModal: false
    };
  }

  componentDidMount = () => {
    window.analytics.track("Views Home Page");
  };

  openCloseFreeModal = bool => {
    this.setState({
      showFreeModal: bool
    });
  };

  startRetro = () => {
    if (!this.props.allDataLoaded) {
      return false;
    }

    if (this.props.currentRetroSession) {
      this.props.startRetro();
      this.props.history.push("/board");
      return true;
    }

    const paymentStatus = this.getPaymentStatus();
    if (paymentStatus === "paid") {
      this.props.startRetro();
      this.props.history.push("/board");
    } else if (paymentStatus === "free trial") {
      this.props.decrementFreeRetros();
      this.props.startRetro();
      this.props.history.push("/board");
    } else if (paymentStatus === "expired") {
      console.error("no more free retros");
      this.openCloseFreeModal(true);

      window.analytics.track("Prevented From Starting New Retro");
    }
  };

  getPaymentStatus = () => {
    if (this.props.payment && this.props.payment.activeSubscription) {
      return "paid";
    } else if (this.props.settings.freeRetros > 0) {
      return "free trial";
    } else {
      return "expired";
    }
  };

  render() {
    const startOrResume = this.props.currentRetroSession ? "Resume" : "Start";
    return (
      <div>
        <Modal
          showFreeModal={this.state.showFreeModal}
          openCloseFreeModal={this.openCloseFreeModal}
        >
          <BecomeMember
            payment={this.props.payment}
            user={this.props.user}
            openCloseFreeModal={this.openCloseFreeModal}
          />
        </Modal>
        <Header
          user={this.props.user}
          freeRetros={this.props.freeRetros}
          payment={this.props.payment}
        />
        <div className="home-container">
          <div className="two-box-container">
            <div className="motivation-container">
              {this.props.allDataLoaded ? (
                <Motivation
                  retroSessions={this.props.retroSessions}
                  type="home"
                />
              ) : (
                <Loader type="line-scale" active />
              )}
            </div>
            <div className="education-container">
              <div className="education-inner-container">
                {
                  // <div className="concerns-image-container">
                  //   <img
                  //     src={concernsBoard}
                  //     alt="concerns-board"
                  //     className="concerns-image"
                  //   />
                  // </div>
                }

                <div className="kudos-concerns">
                  <SectionLabel
                    text="THE OUTRO FORMAT"
                    className="section-label"
                  />
                  <div className="kudos">
                    <img
                      src={kudosIcon}
                      alt="kudos-icon"
                      className="kudos-icon"
                    />
                    <div className="text-container">
                      <h1>1. Kudos</h1>
                      <p>
                        Give shout-outs to team members for doing something
                        positive.
                      </p>
                    </div>
                  </div>
                  <div className="concerns">
                    <img
                      src={concernsIcon}
                      alt="concerns-icon"
                      className="concerns-icon"
                    />
                    <div className="text-container">
                      <h1>2. Concerns</h1>
                      <p>
                        Raise a concern that's on your mind that you want to
                        discuss. Anything goes!
                      </p>
                    </div>
                  </div>
                  <div className="learn-more">
                    <div className="empty-space" />
                    <div className="text-container">
                      <a
                        className="learn-more-link"
                        href={blogPosts.resetOnRetros}
                        target="_blank"
                        onClick={() => {
                          window.analytics.track("Opens Blog Post", {
                            post: "reset on retros"
                          });
                        }}
                      >
                        Read more
                        <img src={arrow} alt="arrow" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="start-retro-container">
            <div onClick={this.startRetro} className="start-retro">
              <div className="border-container">
                <div className="start-icon">
                  <span className="fa fa-play" />
                </div>
                <div className="text">{startOrResume} Retro</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    uid: PropTypes.string.isRequired,
    creationTime: PropTypes.string.isRequired,
    lastSignInTime: PropTypes.string.isRequired,
    photoURL: PropTypes.string
  }),
  retroSessions: PropTypes.array,
  currentRetroSession: PropTypes.shape({
    startTime: PropTypes.number.isRequired,
    concernsAdded: PropTypes.number.isRequired,
    concernsCompleted: PropTypes.number.isRequired,
    kudosGiven: PropTypes.number.isRequired
  }),
  startRetro: PropTypes.func.isRequired,
  freeRetros: PropTypes.number.isRequired,
  payment: PropTypes.shape({
    activeSubscription: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    stripeCustomerID: PropTypes.string.isRequired
  }),
  settings: PropTypes.shape({
    teamName: PropTypes.string,
    frequency: PropTypes.oneOf(["weekly", "bi-weekly", "monthly", "other"])
      .isRequired,
    day: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]).isRequired,
    time: PropTypes.isRequired,
    freeRetros: PropTypes.number.isRequired
  }),
  decrementFreeRetros: PropTypes.func.isRequired,
  dataLoaded: PropTypes.shape({
    allDataLoaded: PropTypes.bool
  })
};

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js